import './App.css';
import InstagramPostList from './InstagramPostList';

function App() {
  return (
     <InstagramPostList/>
  );
}

export default App;
